
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "LoginCheck" })
export default class LoginCheck extends Vue {
  redirect: string = this.$route.query.redirect as string;
}
